import { CLOUDINARY_BASE_URL } from '@99designs/design-services-common';

export function buildCloudinaryURL(imagePath: string): string {
    if (!imagePath || imagePath === '') {
        return '';
    }

    const sanitizedImagePath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    const transformations = ['c_scale', 'dpr_auto', 'f_auto', 'fl_progressive', 'w_450'];

    return `${CLOUDINARY_BASE_URL}${transformations.join(',')}/${sanitizedImagePath}`;
}
